module.exports = __webpack_public_path__ + "static/capcalera-llibre-a08998931d26c86b78ee3194ecc6fb8a.jpg";